var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUptime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uptime_badge-white.svg",
    clipPath: "url(#clip0_62_1238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4389 3.82171C18.4501 3.82171 13.748 5.76486 10.231 9.29194C6.69483 12.819 4.76428 17.5097 4.76428 22.5004C4.76428 27.4929 6.69483 32.1836 10.231 35.7126C13.748 39.2378 18.4501 41.179 23.4389 41.179C28.4278 41.179 33.1299 39.2359 36.6469 35.7088C43.9486 28.4253 43.9486 16.5754 36.6469 9.29194C33.1299 5.76486 28.4278 3.82171 23.4389 3.82171ZM23.439 45C17.418 45 11.7793 42.6613 7.51685 38.4139C3.27347 34.1627 0.922408 28.511 0.941522 22.5C0.941522 16.4871 3.27347 10.8373 7.51685 6.58989C11.7793 2.34057 17.4371 0 23.439 0C29.4601 0 35.0988 2.34057 39.3613 6.58989C48.1347 15.3618 48.1347 29.6382 39.3613 38.4101C35.0988 42.6594 29.4601 45 23.439 45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9264 33.9624C12.6779 33.9624 12.4485 33.8688 12.2574 33.6815C6.08346 27.5177 6.08346 17.4848 12.2574 11.3172C18.4313 5.15532 28.4663 5.15532 34.6211 11.3172C40.795 17.4829 40.795 27.5139 34.6211 33.6777C34.2579 34.0522 33.6463 34.0522 33.2831 33.6777C32.9008 33.3051 32.9008 32.7014 33.2831 32.3269C38.6925 26.9082 38.6925 18.0886 33.2831 12.668C27.8546 7.24941 19.0238 7.24941 13.6145 12.668C8.18604 18.0905 8.18604 26.9101 13.6145 32.3307C13.9777 32.7052 13.9777 33.3089 13.6145 33.6815C13.4233 33.8688 13.1749 33.9624 12.9264 33.9624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4388 31.8018C21.3744 31.8018 19.6924 33.4775 19.6924 35.5448C19.6924 37.6102 21.3744 39.284 23.4388 39.284C25.5031 39.284 27.1852 37.6102 27.1852 35.5448C27.1852 33.4775 25.5031 31.8018 23.4388 31.8018Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8433 36.8187C24.5888 36.8187 25.2769 36.3983 25.6018 35.6895L32.7697 19.6877C33.1902 18.7247 32.7697 17.5936 31.7949 17.1618C30.8392 16.7261 29.7114 17.1656 29.2718 18.1247L22.1039 34.1266C21.6834 35.0895 22.1039 36.2206 23.0787 36.6525C23.3272 36.7652 23.5948 36.8187 23.8433 36.8187Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62_1238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white",
    transform: "translate(0.94043)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUptime);
export default __webpack_public_path__ + "static/media/uptime.e35668639ede66a23774287c0bd33950.svg";
export { ForwardRef as ReactComponent };